import { useState } from "react";

import { Overlay } from "@components/Overlay";
import { OverlayProps } from "@components/Overlay/types";
import { SelectionOption } from "@components/SelectionOption";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { BodySmall, H2 } from "@components/Typography";
import { IncomeAt18 } from "@ctypes";
import { useModal } from "@hooks";
import { Translations, i18n } from "@i18n";
import { AdjustIncomeModalProps } from "./types";

export const AdjustIncomeModal = ({ currentIncome, onUpdate }: AdjustIncomeModalProps) => {
  const { dismiss } = useModal();

  const [income, setIncome] = useState(currentIncome);

  const props: OverlayProps = {
    cta: {
      primary: {
        title: i18n.t(Translations.TrumpSidecarTaxCalculationRouteUpdateCTA),
        onClick: () => {
          onUpdate(income);
          dismiss();
        },
      },
    },
  };

  return (
    <Overlay {...props}>
      <H2>{i18n.t(Translations.TrumpSidecarTaxCalculationRouteAdjustIncomeTitle)}</H2>
      <Spacing size={SpacingSizes.M} />

      <BodySmall>
        {i18n.t(Translations.TrumpSidecarTaxCalculationRouteAdjustIncomeDescription)}
      </BodySmall>
      <Spacing size={SpacingSizes.M} />

      <SelectionOption
        title={i18n.t(Translations.TrumpSidecarTaxCalculationRouteIncomeWorkingFullTime)}
        value={income === IncomeAt18.WorkingFullTime}
        onChange={() => setIncome(IncomeAt18.WorkingFullTime)}
      />
      <Spacing size={SpacingSizes.M} />

      <SelectionOption
        title={i18n.t(Translations.TrumpSidecarTaxCalculationRouteIncomeFullTimeStudent)}
        value={income === IncomeAt18.FullTimeStudent}
        onChange={() => setIncome(IncomeAt18.FullTimeStudent)}
      />
      <Spacing size={SpacingSizes.M} />
    </Overlay>
  );
};
